// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1VCKf","list":"Header_list__3enJP","item":"Header_item__3IlmB","active":"Header_active__vmCnS","line":"Header_line__TnUnq"};